import { Component, OnInit } from '@angular/core';
import { PostnewJob } from '../../services/job-section.service';
import { LoginService } from 'src/app/core/services/login.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-talent-enquiries',
  templateUrl: './talent-enquiries.component.html',
  styleUrls: ['./talent-enquiries.component.scss']
})
export class TalentEnquiriesComponent implements OnInit {

  constructor(private jobService: PostnewJob, private loginService: LoginService, private router: Router) { }
  loginDetails: any;
  myEnquiryAllList: any;
  // myEnquiryJob: any;
  openEnquiryAccordionId: string | null = null;
  enquiryData: any[];
  newMessage: string = '';
  openAccordionId: string | null = null;
  displayMessage: any[] = [];
  EditedMessageId: string = '';

  ngOnInit(): void {
    this.loginDetails = this.loginService.getLoginData();

    this.loadMoreEnquiries();


  }

  // viewJob(job: any): void {
  //   this.router.navigate(['/jobseek/jobdetails', job.id]);
  // }


  limit = 5;
  offset = 0;
  loading = false;
  endOfData = false;

  myEnquiryJob: any[] = [];

  loadMoreEnquiries(): void {

    if (this.loading || this.endOfData) return;

    this.loading = true;

    this.jobService.getMyEnquiryTalent(this.limit, this.offset).subscribe({
      next: (jobs) => {
        console.log("enquiry Data >>>>", jobs);

        const enrichedJobs = jobs;

        if (enrichedJobs.length < this.limit) {
          this.endOfData = true;
        }

        this.myEnquiryJob = [...this.myEnquiryJob, ...enrichedJobs];
        this.offset += this.limit;
        this.loading = false;

      },
      error: (err) => {
        console.error("Error fetching enquiry jobs:", err);
        this.loading = false;
      }
    });


  }

  // Enquiry
  EnquiryAcoordion(jobs: any): void {
    // Close the message accordion when opening the enquiry accordion
    this.openAccordionId = null;
    console.log("jobs>>enquiry accorrdion???", jobs);
    this.enquiryData = [];

    this.openEnquiryAccordionId = this.openEnquiryAccordionId === jobs.id ? null : jobs.id;

    const jobID = jobs?.talent_id;
    const userId = jobs?.enquiry_from;

    this.jobService.getTalentEnquiry(jobID, userId).subscribe((data) => {
      this.enquiryData = data;
      console.log('enquiry data >>>>', data);
    });

  }

  messageAcordion(job: any): void {
    console.log("message open >>>", job);

    // Close the enquiry accordion when opening the message accordion
    this.openEnquiryAccordionId = null;

    this.openAccordionId = this.openAccordionId === job.id ? null : job.id;
    this.newMessage = '';
    // Clear messages first
    this.displayMessage = [];

    this.getAllTalentMessage(job?.jobhirings_find_supplier?.id || job?.jobhirings_find_practice?.id, job?.id);

  }


  getAllTalentMessage(HireId: any, EnquiryId: any) {
    console.log('jobIds', HireId, 'FromId', EnquiryId);

    this.jobService
      .getTalentMessage(HireId, EnquiryId)
      .subscribe((data) => {
        this.displayMessage = data;
        console.log('message >>>', data);
      });
  }



  // send message

  sendMessage(jobId: any): void {
    console.log("send emessage >>>>", jobId);


    if (!this.newMessage.trim()) return; // Do not send empty messages

    // Applied Job Message
    const messages = {
      message: this.newMessage,
      enquiry_message_id_to: jobId?.id,
      message_from: this.loginDetails.id,
      talent_id: jobId.job_profiles?.id,
    };

    this.jobService.addTalentMessage(messages);

    this.newMessage = ''; // Clear the input box
  }


  deleteMessage(messageId: string): void {

    this.jobService.deleteTalentMessage(messageId).then(() => {

    }).catch((err) => {
      console.error("Error deleting message:", err);
    })
  }

  editMessage(message: any): void {
    this.newMessage = message.message;
    this.EditedMessageId = message.id;
  }

  UpdateMessage(editId: any): void {

    const UpdateMessage = {
      id: editId,
      message: this.newMessage,
      updated_at: new Date().toISOString().replace('Z', '+00:00'),
    }

    this.jobService.editTalentMessages(UpdateMessage.id, UpdateMessage.message, UpdateMessage.updated_at).then(() => {
      this.EditedMessageId = '';
      this.newMessage = '';
    })

  }

  trackByJobId(index: number, job: any): string {

    return job.id;
  }

}

